import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import InvitationService from "../../services/invitation.service";
import { PaginationParamsType } from "../../types/common";

// get endorsements by username
export const getInvitationsFromApi: any = createAsyncThunk(
  "invitations/getInvitations",
  async (params: PaginationParamsType) => {
    const res: any = await InvitationService.getAll(params);
    if (res?.response?.status >= 400) {
      throw new Error(res?.response?.data?.error);
    }
    return res || [];
  }
);

const initialState: any = {
  invitations: [],
  totalCount: 0,
  status: "idle",
  error: null,
};

export const invitationSlice = createSlice({
  name: "invitation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Endorsements List By Username
    builder.addCase(getInvitationsFromApi.pending, (state, action) => {
      state.status = "loading";
    });
    builder.addCase(getInvitationsFromApi.fulfilled, (state, action) => {
      state.status = "succeeded";
      state.invitations = action.payload.invitations;
      state.totalCount = action.payload.totalCount;
    });
    builder.addCase(getInvitationsFromApi.rejected, (state, action) => {
      state.status = "failed";
      state.error = action?.error?.message || "Something went wrong";
    });
  },
});

export const getInvitations = (state: RootState) =>
  state.invitation.invitations;
export const getInvitationsTotalCount = (state: RootState) =>
  state.invitation.totalCount;

export default invitationSlice.reducer;
